import { selectPagesWithAssessmentsForSectionOutcomeAndUser } from "./assessment";
import { createAppSelector } from "./base";

export const selectSectionOutcomeAverage = createAppSelector(
  [selectPagesWithAssessmentsForSectionOutcomeAndUser],
  (pagesWithAssessmentsForSectionOutcomeAndUser) => {
    // Only include scored assessments
    const onlyScoredAssessments = pagesWithAssessmentsForSectionOutcomeAndUser.filter(
      (pageAssessment) => pageAssessment.outcomeAssessment?.score,
    );

    if (onlyScoredAssessments.length === 0) {
      return null;
    }

    // Average the scores
    const averageScore =
      onlyScoredAssessments.reduce((acc, pageAssessment) => {
        return acc + pageAssessment.outcomeAssessment.score;
      }, 0) / onlyScoredAssessments.length;

    return averageScore;
  },
);
